import React from "react";
import FooterComponent from "../components/footer/footer";
import MainTopNavComponent from "../components/top-nav/main-top-nav";
import { styled } from "@mui/system";

type IProps = {
  children: any;
};

const MLayout = styled("div")({
  backgroundColor: "var(--kyocera-background-grey) !important",
  overflow: "hidden",
  width: "100%",
  color: "var(--kyocera-dark-grey) !important",

  ".wrapper": {
    flex: "1 1 auto",
    overflow: "hidden",
    paddingTop: 64,
  },
  ".contentContainer": {
    flex: "1 1 auto",
    overflow: "hidden",
  },
  ".content": {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
  },
});

const MainLayout = (props: IProps) => {
  return (
    <MLayout>
      <MainTopNavComponent />
      <div className="wrapper">
        <div className="contentContainer">
          <div className="content">{props.children}</div>
        </div>
      </div>
      <div style={{ position: "fixed", bottom: "0", width: "100%" }}>
        <FooterComponent mainLayout={true} />
      </div>
    </MLayout>
  );
};

export default MainLayout;
